module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account-settings"
  }, [_c('header', {
    staticClass: "mdl-layout__header mdl-color--grey-100 mdl-color-text--grey-600"
  }, [_c('div', {
    staticClass: "mdl-layout__header-row"
  }, [_c('span', [_vm._v(_vm._s(_vm.i18n().title))]), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout-spacer"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cards"
  }, [_c('ChangeUserData'), _vm._v(" "), _c('ChangePassword'), _vm._v(" "), _c('ChangeEmail')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e3fdb2f0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountSettings.vue
// module id = 471
// module chunks = 0